exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-more-data {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\tcolor: #CCC;\n\ttext-align: center;\n\tfont-size: .26rem;\n\tline-height: 1rem;\n}\n.no-more-data::before, .no-more-data::after {\n\tcontent: \"\";\n\twidth: 1rem;\n\theight: 1px;\n\tmargin: 0 .24rem;\n\tbackground-color: #EEE;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e046b26","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/no-more-data.vue
// module id = UdHi
// module chunks = 1